export enum UsabilityCode {
  ALL_AGES = "allAges",
  YOUNG_DRIVER = "youngDriver",
  ADULT_DRIVER = "adultDriver",
}
